import React from 'react'
import PropTypes from 'prop-types'
import Layer from '../Layer'
import classnames from 'classnames'
import {path} from 'd3-path'

export default class Funnel extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    area: PropTypes.bool
  }

  render() {
    const {area, data} = this.props
    if (!data) return null

    const classNames = classnames('funnel', {
      'with-area': area
    })
    return (
      <Layer className={classNames}>
        {this.renderLines()}
        {this.renderArea()}
      </Layer>
    )
  }

  renderLines() {
    const {data} = this.props

    return Object.keys(data).map((key, index) => {
      const lineCoords = data[key].concat()
      const {x, y} = lineCoords.shift()
      const linePath = path()

      linePath.moveTo(x, y)
      lineCoords.forEach(({x, y}) => linePath.lineTo(x, y))

      return (
        <path
          key={index}
          className='funnel_line'
          d={linePath.toString()}
          fill='none'
        />
      )
    })
  }

  renderArea() {
    const {data, area} = this.props
    if (!area) return null

    const sectionPath = path()
    const coords = [...data.left, ...data.right]

    sectionPath.moveTo(0, 0)
    coords.forEach(({x, y}) => sectionPath.lineTo(x, y))

    return (
      <path className='funnel_section' d={sectionPath.toString()} />
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Chart/FunnelChart/Funnel.js